<template>
  <Flex
    v-if="scheduledPriceUpdate"
    v-test="'scheduled-price-update'"
  >
    <BaseCard
      :loading="loading"
      :minLoadingHeight="0"
    >
      <Flex
        justify="between"
        align="center"
      >
        {{ $t('services.price_update.scheduled_price_update', { date: filters.dateTime(scheduledPriceUpdate.scheduledAt), amount: serviceAmount }, serviceAmount) }}
        <BaseMore
          :options="[
            { name: 'view', label: $t('global.actions.view'), icon: 'eye' },
            { name: 'edit', label: $t('global.actions.edit'), icon: 'edit' },
            { name: 'cancel', label: $t('global.actions.cancel'), icon: 'delete' },
          ]"
          @select="onOptionSelect"
          v-test="'scheduled-price-update-actions'"
        />
      </Flex>
    </BaseCard>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import filters from '@/filters';
import { useServicesPriceScheduleStore } from '@/stores/services-price-schedule';

const { cancelScheduledPriceUpdate, getScheduledServicePriceChanges } =
  useServicesPriceScheduleStore();

const { scheduledPriceUpdate, serviceAmount, scheduleFetched } = storeToRefs(
  useServicesPriceScheduleStore(),
);

const router = useRouter();
const onOptionSelect = (option: string) => {
  if (option === 'view') {
    router.push({ name: 'admin-service-scheduled-price-update' });
  }
  if (option === 'edit') {
    router.push({ name: 'admin-service-edit-price-update' });
  }
  if (option === 'cancel') {
    cancelScheduledPriceUpdate();
  }
};

const loading = ref(false);
watch(
  scheduleFetched,
  () => {
    if (scheduleFetched.value) {
      loading.value = true;
      getScheduledServicePriceChanges().then(() => {
        loading.value = false;
      });
    }
  },
  {
    immediate: true,
  },
);
</script>
